module.exports = __webpack_public_path__ + "static/Cases3-42c5dd3fdc3941a0438864b5ea81243b.svg";